import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { PrAgencyPersonaPageBG } from "@/components/site/PrAgencyPersonaPageBG";
import { PR_AGENCY_META_DESCRIPTION_BG } from "@/content/meta/PrAgencyPersonaPageBG";

export const Route = createFileRoute("/bg/who-we-help/pr-agency")({
  head: () => ({
    meta: [
      { title: "Медийно разузнаване за PR агенции | Perceptica" },
      { name: "description", content: PR_AGENCY_META_DESCRIPTION_BG },

      { property: "og:title", content: "Медийно разузнаване за PR агенции | Perceptica" },
      { property: "og:description", content: PR_AGENCY_META_DESCRIPTION_BG },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Медийно разузнаване за PR агенции | Perceptica" },
      { name: "twitter:description", content: PR_AGENCY_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/who-we-help/pr-agency" },
      ...ogImageMeta("bg", "/who-we-help/pr-agency"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/who-we-help/pr-agency" }),
  }),
  component: PrAgencyPersonaPageBG,
});
